import Vue from 'vue';
import _ from 'lodash';
import {
    GET_INCOME_LIST_REQUEST,
    GET_INCOME_LIST_SUCCESS,
    GET_INCOME_LIST_FAILURE,
    UPDATE_INCOME_LIST_PARAMS,
    RESET_INCOME_LIST,
    RESOLVE_INCOME_LIST_PARAMS
} from '../mutationTypes';

const state = {
    loading: false,
    businessType: 1, // 1pc收银订单，2爱车卡PC收银售卡，3爱车卡平台售卡，4套餐营销订单，5当面付，6本店卡订单，7接车施工单，8商品订单
    page: 1,
    pagesize: 20,
    name: '',
    mobile: '',
    carNo: '',
    orderNo: '',
    startEndDate: [], // 组件返回形式为数组, 请求时分开提交
    payType: 0, // 付款方式v2.7
    list: [],
    tableCountInfo: {},
    pageCount: 1,
    reqParams: {},
    createStartEndDate: [] // 下单日期
};

const mutations = {
    [GET_INCOME_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_INCOME_LIST_SUCCESS](state, res) {
        state.loading = false;

        state.pageCount = res.page_count;
        state.list = res.list;
        state.tableCountInfo = res.table_count_info;
    },
    [GET_INCOME_LIST_FAILURE](state) {
        state.loading = false;

        state.pageCount = 1;
        state.list = [];
    },
    [UPDATE_INCOME_LIST_PARAMS](state, params) {
        const {
            name, mobile, page, carNo,
            orderNo, startEndDate, createStartEndDate,
            businessType, payType
        } = params;

        if (name || name === '') state.name = name;
        if (mobile || mobile === '') state.mobile = mobile;
        if (carNo || carNo === '') state.carNo = carNo;
        if (orderNo || orderNo === '') state.orderNo = orderNo;
        if (businessType) state.businessType = businessType;
        if (payType) state.payType = payType;

        if (startEndDate && startEndDate.length) {
            state.startEndDate = startEndDate;
        }
        if (createStartEndDate && createStartEndDate.length) {
            state.createStartEndDate = createStartEndDate;
        }
        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
    },
    [RESET_INCOME_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            businessType: 1,
            page: 1,
            pagesize: 20,
            name: '',
            mobile: '',
            carNo: '',
            orderNo: '',
            startEndDate: [],
            payType: 0,
            list: [],
            pageCount: 1,
            reqParams: {},
            createStartEndDate: []
        }));
    },
    [RESOLVE_INCOME_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getIncomeList({ commit }) {
        commit(GET_INCOME_LIST_REQUEST);
        // let params = _.pick(state, ['name', 'mobile', 'businessType',
        //     'page', 'pagesize', 'carNo', 'orderNo']);

        // params = Object.assign({}, params, {
        //     startDate: state.startEndDate.length ? state.startEndDate[0] : null,
        //     endDate: state.startEndDate.length ? state.startEndDate[1] : null
        // });


        const res = await Vue.$ajax.get('getGainList', state.reqParams);

        if (!res.errorType) {
            commit(GET_INCOME_LIST_SUCCESS, res);
        } else {
            commit(GET_INCOME_LIST_FAILURE);
        }
    },
    resolveIncomeParams({ commit }) {
        let params = _.pick(state, ['name', 'mobile', 'businessType',
            'page', 'pagesize', 'carNo', 'orderNo', 'payType']);
        if (params.payType === -1) {
            params.payType = 0;
        }
        params = Object.assign({}, params, {
            startDate: state.startEndDate.length ? state.startEndDate[0] : null,
            endDate: state.startEndDate.length ? state.startEndDate[1] : null,
            createStartDate: state.createStartEndDate.length ? state.createStartEndDate[0] : null,
            createEndDate: state.createStartEndDate.length ? state.createStartEndDate[1] : null,
        });

        commit(RESOLVE_INCOME_LIST_PARAMS, params);
    },
    resetIncomeList({ commit }) {
        commit(RESET_INCOME_LIST);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/incomeList.js